import { useIntParam } from "hooks";
import { speakingSessionStore } from "store";

export const useExamMaterials = () => {
  const speakingSessionId = useIntParam('sessionId');

  const { data: linkedLrwSessions, isLoading } =
    speakingSessionStore.service.speakingSessionApi.useGetLinkedLrwSessionsQuery({
      speakingSessionId,
    });

  return { linkedLrwSessions, isLoading };
};
